module.exports = __webpack_public_path__ + "media/images/placeholders/slider_placeholder-b36f22f7a569ea40a917c149d59dae8a.png";